import React from 'react';
import './styles.scss';

// Centered full-page state: disabled preview, loading, missing project, handoff errors.
export default function StudioUnavailable({ children }) {
  return <div className="studio-unavailable">{children}</div>;
}
